import type { ReactElement } from 'react'
import type { NamedIconComponentType } from '../icon'

export interface TagProps {
  children?: React.ReactNode
  className?: string
  label?: string
  leadingIcon?: NamedIconComponentType
  rtl?: boolean
  style?: TagStyleType
  variant?: TagVariantType
}

export interface TagDoubleProps {
  leadingIcon?: NamedIconComponentType
  leadingText: string
  trailingIcon?: NamedIconComponentType
  trailingText: string
  rtl?: boolean
  style: TagStyleType
}

export enum TagStyle {
  critical = 'critical',
  loyalty = 'loyalty',
  contrast = 'contrast',
  neutral = 'neutral',
  positive = 'positive',
  promotion = 'promotion',
  sponsored = 'sponsored',
  warning = 'warning',
}

export enum TagVariant {
  primary = 'primary',
  secondary = 'secondary',
}

export type TagComponentType = ReactElement<TagProps>
type TagStyleType = `${TagStyle}`
type TagVariantType = `${TagVariant}`
